export default __webpack_public_path__ + "static/media/workouttimes_3@3x.c0bd1d1d.jpg";